export const DDD_SHARE_THRESHOLD = 5;
export const DEFAULT_PER_PAGE = 10;
export const PER_PAGE_OPTIONS = [10, 25, 50, 100];
export const EXPORT_LIMIT = 20;

export const PER_PAGE_SELECT_OPTIONS = PER_PAGE_OPTIONS.map((option) => ({
	value: option.toString(),
	title: option.toString(),
}));

/** Standard page max-width, aligned with the global `.in` layout (1260px). */
export const AVAILABILITY_PAGE_WIDTH = 'max-w-[1260px]';

/** Wider max-width for the filters and table section only. */
export const AVAILABILITY_CONTENT_WIDTH = 'max-w-[1560px]';

/** Shared horizontal padding for Availability page sections, tightened on small viewports. */
export const AVAILABILITY_CONTENT_PADDING = 'px-4 sm:px-6 xl:px-10';

/**
 * 1-based grid column of every field in the availability table.
 *
 * The selection track is always emitted (collapsed to 0px when selection is off)
 * so these indices never shift.
 */
export const AVAILABILITY_COLUMN = {
	selection: 1,
	rs: 2,
	atc: 3,
	brand: 4,
	pack: 5,
	suklCode: 6,
	share: 7,
	dncDou: 8,
	status: 9,
} as const;

/**
 * Track sizes of the availability table, shared by the header row and every cell.
 * Each track absorbs a 1.5rem gutter that the cells re-apply as `pr-6`, so that
 * sticky header cells tile without see-through gaps between columns.
 *
 * @param {boolean} withSelection whether the selection checkbox column is visible.
 * @returns {string} a `grid-template-columns` value.
 */
export function availabilityGridColumns(withSelection: boolean): string {
	return [
		withSelection ? '2rem' : '0px',
		'5rem', // RS
		'17.5rem', // ATC
		'17rem', // NÁZEV LP
		'minmax(6rem, 1fr)', // DOPLNĚK NÁZVU
		'5.5rem', // SÚKL KÓD
		'14.5rem', // DOSTUPNOST
		'5rem', // DNC/DoÚ
		'3.5rem', // STAV
	].join(' ');
}
